<app-navbar />
<main class="app-shell">
  <router-outlet />
</main>
